import { IconProps } from "../../../utils/global-types/global-types";

const QuoteIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 9"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M1 0a1 1 0 0 0-1 1v2.442a1 1 0 0 0 1 1h1.388q0 .527-.062 1.054a3.5 3.5 0 0 1-.31.992q-.217.435-.56.683-.339.279-.867.279V9q.867 0 1.52-.372a3.3 3.3 0 0 0 1.085-.992 4.9 4.9 0 0 0 .62-1.458A7.7 7.7 0 0 0 4 4.442V1a1 1 0 0 0-1-1zm6 0a1 1 0 0 0-1 1v2.442a1 1 0 0 0 1 1h1.388q0 .527-.062 1.054a3.5 3.5 0 0 1-.31.992q-.217.435-.56.683-.339.279-.867.279V9q.867 0 1.52-.372a3.3 3.3 0 0 0 1.085-.992 4.9 4.9 0 0 0 .62-1.458c.127-.57.19-1.152.186-1.736V1a1 1 0 0 0-1-1z"
      ></path>
    </svg>
  );
};

export default QuoteIcon;
